// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ca-overlay {
    position: fixed;
    inset: 0;
    z-index: 99999;
    padding: 24px;
    display: grid;
    place-items: center;
    background: rgba(23, 23, 20, .5);
    backdrop-filter: blur(6px);
}

.ca-dialog {
    width: min(360px, 100%);
    overflow: hidden;
    border: 1px solid #d8d3c8;
    border-radius: 18px;
    background: #fffefa;
    box-shadow: 0 24px 70px rgba(23, 23, 20, .22);
    animation: ca-enter 180ms ease-out;
}

.ca-dialog.error { border-top: 4px solid #b42318; }
.ca-dialog.success { border-top: 4px solid #267a55; }
.ca-dialog.confirm { border-top: 4px solid #e5482d; }

@keyframes ca-enter {
    from { opacity: 0; transform: translateY(8px); }
    to { opacity: 1; transform: translateY(0); }
}

.ca-body { padding: 30px 24px 22px; }

.ca-message {
    margin: 0;
    color: #171714;
    font-family: Pretendard, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    font-size: 16px;
    font-weight: 750;
    line-height: 1.6;
    text-align: center;
    word-break: keep-all;
}

.ca-footer {
    padding: 0 20px 20px;
    display: flex;
    gap: 9px;
}

.ca-confirm,
.ca-cancel {
    min-height: 48px;
    flex: 1 1;
    border-radius: 10px;
    font-family: Pretendard, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    font-size: 14px;
    font-weight: 800;
    cursor: pointer;
}

.ca-confirm {
    border: 1px solid #171714;
    background: #171714;
    color: #fffefa;
}

.ca-cancel {
    border: 1px solid #d8d3c8;
    background: transparent;
    color: #68665f;
}

.ca-confirm:focus-visible,
.ca-cancel:focus-visible {
    outline: 3px solid #e5482d;
    outline-offset: 3px;
}

@media (prefers-reduced-motion: reduce) {
    .ca-dialog { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/CustomAlert.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,cAAc;IACd,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,6CAA6C;IAC7C,kCAAkC;AACtC;;AAEA,mBAAmB,6BAA6B,EAAE;AAClD,qBAAqB,6BAA6B,EAAE;AACpD,qBAAqB,6BAA6B,EAAE;;AAEpD;IACI,OAAO,UAAU,EAAE,0BAA0B,EAAE;IAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,WAAW,uBAAuB,EAAE;;AAEpC;IACI,SAAS;IACT,cAAc;IACd,kFAAkF;IAClF,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,QAAQ;AACZ;;AAEA;;IAEI,gBAAgB;IAChB,SAAO;IACP,mBAAmB;IACnB,kFAAkF;IAClF,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;;IAEI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,aAAa,eAAe,EAAE;AAClC","sourcesContent":[".ca-overlay {\n    position: fixed;\n    inset: 0;\n    z-index: 99999;\n    padding: 24px;\n    display: grid;\n    place-items: center;\n    background: rgba(23, 23, 20, .5);\n    backdrop-filter: blur(6px);\n}\n\n.ca-dialog {\n    width: min(360px, 100%);\n    overflow: hidden;\n    border: 1px solid #d8d3c8;\n    border-radius: 18px;\n    background: #fffefa;\n    box-shadow: 0 24px 70px rgba(23, 23, 20, .22);\n    animation: ca-enter 180ms ease-out;\n}\n\n.ca-dialog.error { border-top: 4px solid #b42318; }\n.ca-dialog.success { border-top: 4px solid #267a55; }\n.ca-dialog.confirm { border-top: 4px solid #e5482d; }\n\n@keyframes ca-enter {\n    from { opacity: 0; transform: translateY(8px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n.ca-body { padding: 30px 24px 22px; }\n\n.ca-message {\n    margin: 0;\n    color: #171714;\n    font-family: Pretendard, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n    font-size: 16px;\n    font-weight: 750;\n    line-height: 1.6;\n    text-align: center;\n    word-break: keep-all;\n}\n\n.ca-footer {\n    padding: 0 20px 20px;\n    display: flex;\n    gap: 9px;\n}\n\n.ca-confirm,\n.ca-cancel {\n    min-height: 48px;\n    flex: 1;\n    border-radius: 10px;\n    font-family: Pretendard, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n    font-size: 14px;\n    font-weight: 800;\n    cursor: pointer;\n}\n\n.ca-confirm {\n    border: 1px solid #171714;\n    background: #171714;\n    color: #fffefa;\n}\n\n.ca-cancel {\n    border: 1px solid #d8d3c8;\n    background: transparent;\n    color: #68665f;\n}\n\n.ca-confirm:focus-visible,\n.ca-cancel:focus-visible {\n    outline: 3px solid #e5482d;\n    outline-offset: 3px;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .ca-dialog { animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
